import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initBambuserInspiredSlider() {
    $('.bambuser-inspired__slider').each(function () {
        const $carousel = $(this);
        const slideCount = $carousel.find('.swiper-slide').length;
        const windowWidth = $(window).width();
        const minSlides = windowWidth >= 1024 ? 4 : 2;

        if (slideCount >= minSlides) {
            new Swiper(this, {
                modules: [Navigation],
                slidesPerView: 1.5,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                    768: { slidesPerView: 1.5 },
                    1024: { slidesPerView: 3.7 },
                },
            });
        } else {
            $carousel.find('.swiper-button-next, .swiper-button-prev, .swiper-pagination').remove();
        }
    });
}

export default function () {
    initBambuserInspiredSlider();
}